export default class Modal {
    constructor() {
        this.layer = $('.modal__layer')
        this.closers = $('.modal__close')
        this.togglers = $('[data-modal-open]')
        this.frame = $('#modal-video-frame')
    }

    /**
     * Open modal
     */
    openModal(e) {
        let me = $(e.currentTarget)
        let target = $(`#modal-${me.data('modal-open')}`)

        if (target) {
            if (target.attr('id') === 'modal-package' || (target.attr('id') === 'modal-subscription' && me.parent().hasClass('is-selected')) ) {return}
            this.closeAll()

            target.addClass('is-open').fadeIn(250)
            this.layer.addClass('is-open').fadeIn(250)

            if (target.attr('id') === 'modal-package') {
                let targetScroll = me.offset().top - 300

                target.css('top', targetScroll)
                $('html, body').animate({ scrollTop: targetScroll - 80 }, 250)
            } else if (target.attr('id') === 'modal-video') {
                this.layer.addClass('player-mode')
                let code = me.parent('.video, .double-video__item').data('video-code')
                let url = 'https://www.youtube.com/embed/'+code+'?vq=hd1080&rel=0&iv_load_policy=3&modestbranding=1&autoplay=1&color=white&enablejsapi=1&playerapiid=ytplayer'

                $('body').addClass('no-scroll')
                this.frame.attr('src', url).contentWindow.postMessage('{"event":"command","func":"' + 'startVideo' + '","args":""}', '*');
            } else if (target.attr('id') === 'modal-gdpr') {
                $('#modal-gdpr-container').addClass('is-open')
                $('.modal__layer').removeClass('is-open').hide()
                $('body').addClass('no-scroll')
            } else {
                $('html, body').animate({ scrollTop: 0 }, 250)
            }
        }
    }

    /**
     * stop modal video
     */
    hideVideo() {
        if (this.frame.length) {
            this.frame[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            this.frame.attr('src', '')
            this.layer.removeClass('player-mode')
            $('#modal-video').hide()
        }
    }

    /**
     * Close all modals
     */
    closeAll() {
        $('.modal, .modal-layer, .header__link, .navigation, .dropdown, #modal-video, #modal-gdpr-container').removeClass('is-open')
        $('.modal, .modal__layer').fadeOut(250)
        $('.header__toggler').removeClass('is-active')
        $('body').removeClass('no-scroll')
        this.hideVideo()
    }

    isGdprModalVisible() {
        return $('#modal-gdpr').hasClass('is-open') || $('#modal-gdpr-info').hasClass('is-open')
    }

    /**
     * Initialize class
     */
    init() {
        // Open specific modal
        if (this.togglers) {
            this.togglers.on('click', e => this.openModal(e))
        }

        // Close on layer click
        if (this.layer) {
            this.layer.on('click', () => this.closeAll())
        }

        // Close on X button
        if (this.closers) {
            this.closers.on('click', () => this.closeAll())
        }

        // Close on Esc key
        $(document).on('keyup', e => {
            if (e.keyCode === 27 && !this.isGdprModalVisible()) {
                this.closeAll()
            }
        })
    }
}
